import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import * as actions from '../actions';
import { IEmployeeBusinessesLoadState, IEmployeeBusinessesResponse } from '../models/employee-business-detail.model';

export const employeeBusinessesKey = 'getEmployeeBusinesses';

export interface EmployeeBusinessesState {
  employeeBusinessesRequest: IEmployeeBusinessesLoadState | undefined;
  employeeBusinessesResponse: IEmployeeBusinessesResponse;
  employeeBusinessesFailure: IGenericError<ErrorResponse>;
}

export const initialState: EmployeeBusinessesState = {
  employeeBusinessesRequest: undefined,
  employeeBusinessesResponse: undefined,
  employeeBusinessesFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadEmployeeBusinesses, (state, action) => ({
    ...state,
    employeeBusinessesRequest: { employeeId: action.employeeId, businessIds: action.model.businessIds }
  })),
  on(actions.loadEmployeeBusinessesSuccess, (state, action) => ({
    ...state,
    employeeBusinessesResponse: action.response
  })),
  on(actions.loadEmployeeBusinessesFailure, (state, action) => ({
    ...state,
    employeeBusinessesFailure: action.error
  }))
);

export const getEmployeeBusinessesRequest = (
  state: EmployeeBusinessesState
): IEmployeeBusinessesLoadState | undefined => state.employeeBusinessesRequest;
export const getEmployeeBusinessesResponse = (state: EmployeeBusinessesState) => {
  return state.employeeBusinessesResponse;
};
export const getEmployeeBusinessesFailure = (state: EmployeeBusinessesState) => state.employeeBusinessesFailure;
